import materialTheme from "./material";
import grayscaleTheme from "./grayscale";
export default {
  material: materialTheme,
  grayscale: grayscaleTheme
};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/victory-theme/victory-theme.js
// module id = 2467
// module chunks = 0